<template>
  <div>
    <ed-form
      :data="formData"
      :config="config"
      :response="response"
      :itens="fatorRiscoItems"
    >
      <div slot="form-footer">
        <Laboratorios :parent="this" />
      </div>
    </ed-form>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import FormItems from "./_form/risco-cadastrar";
import FormLaboratorioItems from "./_form/laboratorio-cadastrar";
import Laboratorios from "./_includes/laboratorio";

export default {
  name: "exame-editar",
  components: { EdForm, Laboratorios },
  mixins: [Rest],
  watch: {},
  data() {
    return {
      config: {
        tipo: [269,290],
        hidden: {},
        click: {
          save: this.salvar,
          id_tab: this.getTabelaDinamica,
          esocial_atividade_per: this.getEscocialTabela28,
        },
        loading: {
          save: false,
          content: false,
          id_tab: false,
          esocial_atividade_per: false,
        },
        list: {
          id_tab: [],
          esocial_atividade_per: [],
        },
      },
      formData: {
        id: 0,
        nome: null,
        nome_comercial: null,
        cod_cas: null,
        cod_esocial: null,
        cod_metodologia: null,
        desc_metodologia: null,
        id_tipo_unidade_medida:null,
        id_tab: null,
        un_medida: null,
        amostra: null,
        vazao: null,
        volume: null,
        cod_amostrador: null,
        desc_amostrador: null,
        usuario: null,
        laboratorio: null,
        id_lab: null,
        laboratorios: [],
				        esocial_atividade_per: [],
        ativo: 1,
      },
      response: {},
      fatorRiscoItems: [],
    };
  },

  mounted: function () {
    this.fatorRiscoItems = FormItems;
    this.laboratorioItems = FormLaboratorioItems;
    this.getFatorRisco();
    this.getTabelaDinamica();
		this.getEscocialTabela28();
  },

  methods: {
    getEscocialTabela28: function (_search) {
      this.config.loading.esocial_atividade_per = true;
      this.config.list.esocial_atividade_per = [];

      this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(
        (result) => {
          result = result[0];

          this.config.loading.esocial_atividade_per = false;

          if (result.status == 200) {
            this.config.list.esocial_atividade_per = result.data.data;
          }
        }
      );
    },

    getTabelaDinamica(_search) {
      this.config.loading.id_tab = true;
      this.config.list.id_tab = [];

      this.get("/ltcat/tabela-dinamica", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_tab = false;

        if (result.status == 200) {
          this.config.list.id_tab = result.data.data;
        }
      });
    },

    getFatorRisco() {
      this.config.loading.content = true;

      this.get("fator-risco/" + this.$route.params.id).then((result) => {
        result = result[0];

        this.config.loading.content = false;

        if (result.status == 200) {
          this.formatData(result);
        }
      });
    },

    formatData(result) {
      this.formData = result.data;
    },

    salvar() {
      this.response = {};
      this.config.loading.save = true;

      this.post("fator-risco/editar", this.formData).then((result) => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.formatData(result);
          this.$message({
            message: "Registro salvo com sucesso!",
            type: "success",
          });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// editar.vue?19453a7a